import React from 'react'
import styles from './AddRecipientSuccess.styles'
import Button from '../../../../components/button/Button'
import { BUTTON_TYPE } from '../../../../components/button/constants'
import BasicCard from '../../../../components/card/basiccard/BasicCard'
import Heading from '../../../../components/heading/Heading'
import { HEADING } from '../../../../components/heading/constants/constants'
import Icons from '../../../../components/icons/Icons'
import { VEC_ICON_NAME } from '../../../../components/icons/constants'
import { Col, Row } from 'reactstrap'
import HorizontalSeparator from '../../../../components/separator/horizontalSeparator/HorizontalSeparator'
import { useDispatch, useSelector } from 'react-redux'
import { componentKey, resetAddRecipientSlice, setRecipientCreationSuccess } from '../AddRecipientSlice'
import { RECIPIENT_SECTION_ROUTES } from '../../../recipientssection/constants'
import { componentKey as authenticationSliceKey } from '../../../authentication/AuthenticationSlice'
import { isDisplayPlansView } from '../w8w9paymentmodals/W8W9PaymentModalSaga'
import { RECIPIENT_TYPE_TITLE } from '../getrecipienttype/constants'
import { isAccessAllowed, useUserPermissionsInfo } from '../../../dashboard/hooks/userHooks'
import { PAGE_PERMISSIONS } from '../../../dashboard/constants/constant'
import { setShowPaymentNotAllowedPopup } from '../../../dashboard/DashboardSlice'
import useTxNavigate from '../../../../../libs/txnavigate/TxNavigateHook'

const AddRecipientSuccess = ({ setRefreshStep, isEdited = false }) => {

    const navigate = useTxNavigate();
    const { signedInUser } = useSelector(state => state[authenticationSliceKey])
    const { recipientBasicInfo, RecipientType, RequestType, W8W9Fees } = useSelector(state => state[componentKey]);
    const { permissions } = useUserPermissionsInfo();
    const dispatch = useDispatch();

    return (

        <div style={styles.container}>

            <BasicCard alignItems="center" customStyles={styles.card}>

                <div style={styles.cardHeader}>
                    <Heading type={HEADING.H1}>{`${recipientBasicInfo?.RecipientFirstName?.value} ${recipientBasicInfo?.RecipientLastName?.value}${isEdited ? "'s information has been updated" : " has been successfully added as a recipient."} `}</Heading>
                    <div>
                        <Icons familyName="vec" iconName={VEC_ICON_NAME.BANK_LOGO_ICON} />
                    </div>
                </div>

                {RequestType && <div style={styles.cardInfo}>
                    <div style={styles.invoiceLogo}>
                        <Icons familyName="vec" iconName={VEC_ICON_NAME.INVOICE_LOGO_ICON} />
                    </div>
                    <Heading type={HEADING.H1}>{`You have a pending payment. Pay now to start processing these requests.`}</Heading>
                </div>}

                <HorizontalSeparator style={styles.grayBorder} />

                <div className='w-100'>
                    <label style={styles.einNumber}>{recipientBasicInfo?.RecipientFirstName?.value} {recipientBasicInfo?.RecipientLastName?.value}  {RecipientType === RECIPIENT_TYPE_TITLE.INDIVIDUAL ? "SSN" : "EIN"} : {recipientBasicInfo?.RecipientTIN?.value}</label>

                    {RequestType && <>
                        <Row>
                            <Col xs={3}>{RequestType}</Col>
                            <Col xs={6}>${W8W9Fees}</Col>
                        </Row>
                        <HorizontalSeparator style={styles.separator} />

                        <Heading type={HEADING.H3} >
                            <Row>
                                <Col xs={3}>Total Bill</Col>
                                <Col xs={6}>${W8W9Fees}</Col>
                            </Row>
                        </Heading>
                    </>}
                </div>
            </BasicCard>

            <p style={styles.questionText}>What would you like to do next?</p>

            <div style={styles.buttonsContainer}>
                {RequestType && <Button
                    type={BUTTON_TYPE.PRIMARY}
                    style={styles.button}
                    onClickCb={() => {
                        if(isAccessAllowed(PAGE_PERMISSIONS.PAYMENTS, permissions )) {
                            dispatch(isDisplayPlansView({ requestType: RequestType }))
                        } else {
                            dispatch(setShowPaymentNotAllowedPopup(true))
                        }
                    }}
                >
                    Pay bill now
                </Button>}

                {!isEdited && <Button
                    type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER}
                    style={styles.button}
                    onClickCb={() => {
                        dispatch(setRecipientCreationSuccess(false));
                        dispatch(resetAddRecipientSlice({ signedInUser }));
                        setRefreshStep(0);
                        navigate(`/${RECIPIENT_SECTION_ROUTES.RECIPIENT}/${RECIPIENT_SECTION_ROUTES.ADD}`);
                    }}>
                    Add another recipient
                </Button>}

                <Button
                    type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER}
                    style={styles.button}
                    onClickCb={() => navigate(`/`)}>
                    Go to dashboard
                </Button>
            </div>
        </div>
    )
}

export default AddRecipientSuccess
